import { Box, Typography } from "@mui/material";

function EnvironmentBanner({env}) {
    const ENV_CONFIG = {
        staging: {
            label: 'Staging',
            message: 'You are testing in staging',
        },
        sandbox: {
            label: 'Sandbox',
            message: 'You are testing in a sandbox',
        },
    };

    if (env === 'production' || env === '') {
        return null;
    }

    const config = ENV_CONFIG[env] ? ENV_CONFIG[env] : { label: env, message: '' };
    return (
        <Box
            sx={{
                height: 38,
                bgcolor: "rgb(255,130,130)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 3,
                fontSize: 14,
                fontWeight: 500,
            }}
        >
            <Typography fontWeight={600}>
                {config?.label}
            </Typography>
            <Typography sx={{color: "#fff"}}>
                {config?.message}
            </Typography>
            <Box width={80} />
        </Box>
    );
}

export default EnvironmentBanner;